import React from 'react';
import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react';
import { useDescope } from '@descope/react-sdk';

import { Banner } from 'core/components/banner';
import { Button } from 'core/components/button';
import { Label } from 'core/components/label';
import { signOut as cognitoLogout } from 'core/components/auth';
import useSession from 'core/hooks/use-session';

import useStyles from './agency-claims-banner.styles';

// Shown when the session's ID token still lacks the agency-claims marker after one forced refresh. The
// backend then refuses every agency-scoped request (customer and offer pages, UW notes, LOE, search,
// documents), so a fresh sign-in is the fix (#36202).
const AgencyClaimsBanner = observer(() => {
  const classes = useStyles();
  const session = useSession();
  const { logout: descopeLogout } = useDescope();

  const handleSignOut = async () => {
    await cognitoLogout();
    await descopeLogout();
  };

  return (
    <Banner color="orange" show={!!session.agencyClaimsUnverified} iconType="alert">
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid container item xs={8} alignItems="center">
          <Label type="smallWhiteBold">
            We couldn't verify your access for this session, so customer records, search and documents may be
            unavailable. Please sign out and sign in again.
          </Label>
        </Grid>
        <Button variant="contained" className={classes.signOutButton} onClick={handleSignOut}>
          Sign out
        </Button>
      </Grid>
    </Banner>
  );
});

export default AgencyClaimsBanner;
